//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PLAS.js";
import "../PDM/PDM.ElementGroup.js";
import "../no/PDM.js";
let d=[[],[[["destinationRun","oldbranch"],"ReparentBranch",{R_:{newbranch:"PDM.OrderedElementGroup"}},2,0],[["count","branches"],"GetBranches",{},0,0]],[]];
SPLM.PLAS.Run = class extends SPLM.PDM.ElementGroup{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PLAS.Run";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;